<template>
  <div class="not-found-page">
    <a href="https://www.plinga.com/">
      <img
        class="not-found-img"
        src="/img/404_page.jpg"
        alt="GameDistribution+ Page Not Found"
      />
    </a>
  </div>
</template>

<script>
export default {};
</script>

<style>
/* @font-face {
        font-family: 'Berlin Sans FB Demi';
        src: url('/assets/fonts/berlin-sans-fb-demi.ttf');
    } */
.not-found-page {
  width: 60%;
  height: 100%;
  position: relative;
  margin: auto;
}
.not-found-img {
  /* position: absolute; */
  width: 100%;
  margin: 0 auto;
  /* padding-left: 30px; */
}

.p1 {
  top: -40px;
  font-size: 72px;
  font-size: 4.3vw;
}
.p2 {
  top: 33vw;
  font-size: 50px;
  font-size: 3.5vw;
}
.p3 {
  top: 36vw;
  font-size: 50px;
  font-size: 3.5vw;
}
</style>
